import React from 'react'
import TourPackagesWorker from './tour-packages'
import { Link, withRouter } from 'react-router-dom'
import iconEdit from '../../../assets/icons/edit-black.svg'
import iconDelete from '../../../assets/icons/delete-black.svg'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import NumberFormat from 'react-number-format'

class TourPackages extends React.Component {

    constructor() {
        super()
        this.tourPackagesWorker = TourPackagesWorker(this)
        this.state = this.tourPackagesWorker.getDefaultState()
    }

    componentDidMount() {
        this.tourPackagesWorker.loadTourPackages()
    }

    onDelete = id => this.tourPackagesWorker.deleteTourPackage(id)

    getStatusLabel = status => {
        switch (Number(status)) {
            case 0:
                return "Draft"
            case 1:
                return "Published"
            case 2:
                return "Archived"
            default:
                return status
        }
    }

    render() {
        return (
            <div className="tour-packages">
                {
                    this.state.loading && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/tour-packages/create">New Tour Package</Link>
                    <div className="header">
                        <h4>Tour Packages</h4>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Location</th>
                                <th>Travel Date</th>
                                <th>Duration</th>
                                <th>Price</th>
                                <th>Status</th>
                                <th>Created</th>
                                <th>Updated</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.tourPackages.map((tourPackage, key) => {
                                    const createdAt = tourPackage.createdAt || tourPackage.created
                                    const updatedAt = tourPackage.updatedAt || tourPackage.updated
                                    return (
                                        <tr key={key}>
                                            <td>{tourPackage.name}</td>
                                            <td>{tourPackage.city}, {tourPackage.country}</td>
                                            <td>{tourPackage.travelDate}</td>
                                            <td>{tourPackage.duration}</td>
                                            <td>
                                                <NumberFormat value={tourPackage.price} displayType="text" thousandSeparator={true} prefix="₦" />
                                            </td>
                                            <td>{this.getStatusLabel(tourPackage.status)}</td>
                                            <td>{createdAt ? new Date(createdAt).toLocaleString() : "-"}</td>
                                            <td>{updatedAt ? new Date(updatedAt).toLocaleString() : "-"}</td>
                                            <td>
                                                <div className="actions">
                                                    <img alt="" src={iconEdit} onClick={() => this.props.history.push('/content/tour-packages/edit/' + tourPackage.id)} />
                                                    {
                                                        this.state.deletingId === tourPackage.id ? <Loading /> : <img alt="" src={iconDelete} onClick={() => this.onDelete(tourPackage.id)} />
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default withRouter(TourPackages)
